"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryClientImpl = exports.QueryAllDelegatorUnbondingEpochEntriesResponse = exports.QueryAllDelegatorUnbondingEpochEntriesRequest = exports.QueryDepositModuleAccountResponse = exports.QueryDepositModuleAccountRequest = exports.QueryHostAccountsResponse = exports.QueryHostAccountsRequest = exports.QueryDelegatorUnbondingEpochEntryResponse = exports.QueryDelegatorUnbondingEpochEntryRequest = exports.QueryHostAccountUndelegationResponse = exports.QueryHostAccountUndelegationRequest = exports.QueryUnbondingEpochCValueResponse = exports.QueryUnbondingEpochCValueRequest = exports.QueryPendingUnbondingsResponse = exports.QueryPendingUnbondingsRequest = exports.QueryFailedUnbondingsResponse = exports.QueryFailedUnbondingsRequest = exports.QueryUnclaimedResponse = exports.QueryUnclaimedRequest = exports.QueryIBCTransientStoreResponse = exports.QueryIBCTransientStoreRequest = exports.QueryModuleStateResponse = exports.QueryModuleStateRequest = exports.QueryCValueResponse = exports.QueryCValueRequest = exports.QueryAllowListedValidatorsResponse = exports.QueryAllowListedValidatorsRequest = exports.QueryDelegationStateResponse = exports.QueryDelegationStateRequest = exports.QueryHostChainParamsResponse = exports.QueryHostChainParamsRequest = exports.QueryAllStateResponse = exports.QueryAllStateRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const params_1 = require("./params");
const genesis_1 = require("./genesis");
const lscosmos_1 = require("./lscosmos");
const coin_1 = require("../../../cosmos/base/v1beta1/coin");
const binary_1 = require("../../../binary");
const helpers_1 = require("../../../helpers");
exports.protobufPackage = "pstake.lscosmos.v1beta1";
function createBaseQueryParamsRequest() {
    return {};
}
exports.QueryParamsRequest = {
    encode(_, writer = binary_1.BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const obj = createBaseQueryParamsRequest();
        return obj;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryParamsRequest();
        return message;
    },
};
function createBaseQueryParamsResponse() {
    return {
        params: params_1.Params.fromPartial({}),
    };
}
exports.QueryParamsResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.params !== undefined) {
            params_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = params_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryParamsResponse();
        if ((0, helpers_1.isSet)(object.params))
            obj.params = params_1.Params.fromJSON(object.params);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined && (obj.params = message.params ? params_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryParamsResponse();
        if (object.params !== undefined && object.params !== null) {
            message.params = params_1.Params.fromPartial(object.params);
        }
        return message;
    },
};
function createBaseQueryAllStateRequest() {
    return {};
}
exports.QueryAllStateRequest = {
    encode(_, writer = binary_1.BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllStateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const obj = createBaseQueryAllStateRequest();
        return obj;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryAllStateRequest();
        return message;
    },
};
function createBaseQueryAllStateResponse() {
    return {
        genesis: genesis_1.GenesisState.fromPartial({}),
    };
}
exports.QueryAllStateResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.genesis !== undefined) {
            genesis_1.GenesisState.encode(message.genesis, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllStateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.genesis = genesis_1.GenesisState.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryAllStateResponse();
        if ((0, helpers_1.isSet)(object.genesis))
            obj.genesis = genesis_1.GenesisState.fromJSON(object.genesis);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.genesis !== undefined &&
            (obj.genesis = message.genesis ? genesis_1.GenesisState.toJSON(message.genesis) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAllStateResponse();
        if (object.genesis !== undefined && object.genesis !== null) {
            message.genesis = genesis_1.GenesisState.fromPartial(object.genesis);
        }
        return message;
    },
};
function createBaseQueryHostChainParamsRequest() {
    return {};
}
exports.QueryHostChainParamsRequest = {
    encode(_, writer = binary_1.BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryHostChainParamsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const obj = createBaseQueryHostChainParamsRequest();
        return obj;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryHostChainParamsRequest();
        return message;
    },
};
function createBaseQueryHostChainParamsResponse() {
    return {
        hostChainParams: lscosmos_1.HostChainParams.fromPartial({}),
    };
}
exports.QueryHostChainParamsResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.hostChainParams !== undefined) {
            lscosmos_1.HostChainParams.encode(message.hostChainParams, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryHostChainParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hostChainParams = lscosmos_1.HostChainParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryHostChainParamsResponse();
        if ((0, helpers_1.isSet)(object.hostChainParams))
            obj.hostChainParams = lscosmos_1.HostChainParams.fromJSON(object.hostChainParams);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.hostChainParams !== undefined &&
            (obj.hostChainParams = message.hostChainParams
                ? lscosmos_1.HostChainParams.toJSON(message.hostChainParams)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryHostChainParamsResponse();
        if (object.hostChainParams !== undefined && object.hostChainParams !== null) {
            message.hostChainParams = lscosmos_1.HostChainParams.fromPartial(object.hostChainParams);
        }
        return message;
    },
};
function createBaseQueryDelegationStateRequest() {
    return {};
}
exports.QueryDelegationStateRequest = {
    encode(_, writer = binary_1.BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegationStateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const obj = createBaseQueryDelegationStateRequest();
        return obj;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryDelegationStateRequest();
        return message;
    },
};
function createBaseQueryDelegationStateResponse() {
    return {
        delegationState: lscosmos_1.DelegationState.fromPartial({}),
    };
}
exports.QueryDelegationStateResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.delegationState !== undefined) {
            lscosmos_1.DelegationState.encode(message.delegationState, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegationStateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegationState = lscosmos_1.DelegationState.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryDelegationStateResponse();
        if ((0, helpers_1.isSet)(object.delegationState))
            obj.delegationState = lscosmos_1.DelegationState.fromJSON(object.delegationState);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.delegationState !== undefined &&
            (obj.delegationState = message.delegationState
                ? lscosmos_1.DelegationState.toJSON(message.delegationState)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDelegationStateResponse();
        if (object.delegationState !== undefined && object.delegationState !== null) {
            message.delegationState = lscosmos_1.DelegationState.fromPartial(object.delegationState);
        }
        return message;
    },
};
function createBaseQueryAllowListedValidatorsRequest() {
    return {};
}
exports.QueryAllowListedValidatorsRequest = {
    encode(_, writer = binary_1.BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllowListedValidatorsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const obj = createBaseQueryAllowListedValidatorsRequest();
        return obj;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryAllowListedValidatorsRequest();
        return message;
    },
};
function createBaseQueryAllowListedValidatorsResponse() {
    return {
        allowListedValidators: lscosmos_1.AllowListedValidators.fromPartial({}),
    };
}
exports.QueryAllowListedValidatorsResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.allowListedValidators !== undefined) {
            lscosmos_1.AllowListedValidators.encode(message.allowListedValidators, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllowListedValidatorsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.allowListedValidators = lscosmos_1.AllowListedValidators.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryAllowListedValidatorsResponse();
        if ((0, helpers_1.isSet)(object.allowListedValidators))
            obj.allowListedValidators = lscosmos_1.AllowListedValidators.fromJSON(object.allowListedValidators);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.allowListedValidators !== undefined &&
            (obj.allowListedValidators = message.allowListedValidators
                ? lscosmos_1.AllowListedValidators.toJSON(message.allowListedValidators)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAllowListedValidatorsResponse();
        if (object.allowListedValidators !== undefined && object.allowListedValidators !== null) {
            message.allowListedValidators = lscosmos_1.AllowListedValidators.fromPartial(object.allowListedValidators);
        }
        return message;
    },
};
function createBaseQueryCValueRequest() {
    return {};
}
exports.QueryCValueRequest = {
    encode(_, writer = binary_1.BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryCValueRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const obj = createBaseQueryCValueRequest();
        return obj;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryCValueRequest();
        return message;
    },
};
function createBaseQueryCValueResponse() {
    return {
        cValue: "",
    };
}
exports.QueryCValueResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.cValue !== "") {
            writer.uint32(10).string(message.cValue);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryCValueResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.cValue = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryCValueResponse();
        if ((0, helpers_1.isSet)(object.cValue))
            obj.cValue = String(object.cValue);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.cValue !== undefined && (obj.cValue = message.cValue);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryCValueResponse();
        message.cValue = object.cValue ?? "";
        return message;
    },
};
function createBaseQueryModuleStateRequest() {
    return {};
}
exports.QueryModuleStateRequest = {
    encode(_, writer = binary_1.BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryModuleStateRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const obj = createBaseQueryModuleStateRequest();
        return obj;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryModuleStateRequest();
        return message;
    },
};
function createBaseQueryModuleStateResponse() {
    return {
        moduleState: false,
    };
}
exports.QueryModuleStateResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.moduleState === true) {
            writer.uint32(8).bool(message.moduleState);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryModuleStateResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.moduleState = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryModuleStateResponse();
        if ((0, helpers_1.isSet)(object.moduleState))
            obj.moduleState = Boolean(object.moduleState);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.moduleState !== undefined && (obj.moduleState = message.moduleState);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryModuleStateResponse();
        message.moduleState = object.moduleState ?? false;
        return message;
    },
};
function createBaseQueryIBCTransientStoreRequest() {
    return {};
}
exports.QueryIBCTransientStoreRequest = {
    encode(_, writer = binary_1.BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryIBCTransientStoreRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const obj = createBaseQueryIBCTransientStoreRequest();
        return obj;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryIBCTransientStoreRequest();
        return message;
    },
};
function createBaseQueryIBCTransientStoreResponse() {
    return {
        iBCTransientStore: lscosmos_1.IBCAmountTransientStore.fromPartial({}),
    };
}
exports.QueryIBCTransientStoreResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.iBCTransientStore !== undefined) {
            lscosmos_1.IBCAmountTransientStore.encode(message.iBCTransientStore, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryIBCTransientStoreResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.iBCTransientStore = lscosmos_1.IBCAmountTransientStore.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryIBCTransientStoreResponse();
        if ((0, helpers_1.isSet)(object.iBCTransientStore))
            obj.iBCTransientStore = lscosmos_1.IBCAmountTransientStore.fromJSON(object.iBCTransientStore);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.iBCTransientStore !== undefined &&
            (obj.iBCTransientStore = message.iBCTransientStore
                ? lscosmos_1.IBCAmountTransientStore.toJSON(message.iBCTransientStore)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryIBCTransientStoreResponse();
        if (object.iBCTransientStore !== undefined && object.iBCTransientStore !== null) {
            message.iBCTransientStore = lscosmos_1.IBCAmountTransientStore.fromPartial(object.iBCTransientStore);
        }
        return message;
    },
};
function createBaseQueryUnclaimedRequest() {
    return {
        delegatorAddress: "",
    };
}
exports.QueryUnclaimedRequest = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUnclaimedRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryUnclaimedRequest();
        if ((0, helpers_1.isSet)(object.delegatorAddress))
            obj.delegatorAddress = String(object.delegatorAddress);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryUnclaimedRequest();
        message.delegatorAddress = object.delegatorAddress ?? "";
        return message;
    },
};
function createBaseQueryUnclaimedResponse() {
    return {
        unclaimed: [],
    };
}
exports.QueryUnclaimedResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        for (const v of message.unclaimed) {
            lscosmos_1.UnbondingEpochCValue.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUnclaimedResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.unclaimed.push(lscosmos_1.UnbondingEpochCValue.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryUnclaimedResponse();
        if (Array.isArray(object?.unclaimed))
            obj.unclaimed = object.unclaimed.map((e) => lscosmos_1.UnbondingEpochCValue.fromJSON(e));
        return obj;
    },
    toJSON(message) {
        const obj = {};
        if (message.unclaimed) {
            obj.unclaimed = message.unclaimed.map((e) => (e ? lscosmos_1.UnbondingEpochCValue.toJSON(e) : undefined));
        }
        else {
            obj.unclaimed = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryUnclaimedResponse();
        message.unclaimed = object.unclaimed?.map((e) => lscosmos_1.UnbondingEpochCValue.fromPartial(e)) || [];
        return message;
    },
};
function createBaseQueryFailedUnbondingsRequest() {
    return {
        delegatorAddress: "",
    };
}
exports.QueryFailedUnbondingsRequest = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryFailedUnbondingsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryFailedUnbondingsRequest();
        if ((0, helpers_1.isSet)(object.delegatorAddress))
            obj.delegatorAddress = String(object.delegatorAddress);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryFailedUnbondingsRequest();
        message.delegatorAddress = object.delegatorAddress ?? "";
        return message;
    },
};
function createBaseQueryFailedUnbondingsResponse() {
    return {
        failedUnbondings: [],
    };
}
exports.QueryFailedUnbondingsResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        for (const v of message.failedUnbondings) {
            lscosmos_1.UnbondingEpochCValue.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryFailedUnbondingsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.failedUnbondings.push(lscosmos_1.UnbondingEpochCValue.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryFailedUnbondingsResponse();
        if (Array.isArray(object?.failedUnbondings))
            obj.failedUnbondings = object.failedUnbondings.map((e) => lscosmos_1.UnbondingEpochCValue.fromJSON(e));
        return obj;
    },
    toJSON(message) {
        const obj = {};
        if (message.failedUnbondings) {
            obj.failedUnbondings = message.failedUnbondings.map((e) => e ? lscosmos_1.UnbondingEpochCValue.toJSON(e) : undefined);
        }
        else {
            obj.failedUnbondings = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryFailedUnbondingsResponse();
        message.failedUnbondings = object.failedUnbondings?.map((e) => lscosmos_1.UnbondingEpochCValue.fromPartial(e)) || [];
        return message;
    },
};
function createBaseQueryPendingUnbondingsRequest() {
    return {
        delegatorAddress: "",
    };
}
exports.QueryPendingUnbondingsRequest = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPendingUnbondingsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryPendingUnbondingsRequest();
        if ((0, helpers_1.isSet)(object.delegatorAddress))
            obj.delegatorAddress = String(object.delegatorAddress);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryPendingUnbondingsRequest();
        message.delegatorAddress = object.delegatorAddress ?? "";
        return message;
    },
};
function createBaseQueryPendingUnbondingsResponse() {
    return {
        pendingUnbondings: [],
    };
}
exports.QueryPendingUnbondingsResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        for (const v of message.pendingUnbondings) {
            lscosmos_1.UnbondingEpochCValue.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryPendingUnbondingsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.pendingUnbondings.push(lscosmos_1.UnbondingEpochCValue.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryPendingUnbondingsResponse();
        if (Array.isArray(object?.pendingUnbondings))
            obj.pendingUnbondings = object.pendingUnbondings.map((e) => lscosmos_1.UnbondingEpochCValue.fromJSON(e));
        return obj;
    },
    toJSON(message) {
        const obj = {};
        if (message.pendingUnbondings) {
            obj.pendingUnbondings = message.pendingUnbondings.map((e) => e ? lscosmos_1.UnbondingEpochCValue.toJSON(e) : undefined);
        }
        else {
            obj.pendingUnbondings = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryPendingUnbondingsResponse();
        message.pendingUnbondings =
            object.pendingUnbondings?.map((e) => lscosmos_1.UnbondingEpochCValue.fromPartial(e)) || [];
        return message;
    },
};
function createBaseQueryUnbondingEpochCValueRequest() {
    return {
        epochNumber: BigInt(0),
    };
}
exports.QueryUnbondingEpochCValueRequest = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.epochNumber !== BigInt(0)) {
            writer.uint32(8).int64(message.epochNumber);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUnbondingEpochCValueRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.epochNumber = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryUnbondingEpochCValueRequest();
        if ((0, helpers_1.isSet)(object.epochNumber))
            obj.epochNumber = BigInt(object.epochNumber.toString());
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.epochNumber !== undefined && (obj.epochNumber = (message.epochNumber || BigInt(0)).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryUnbondingEpochCValueRequest();
        if (object.epochNumber !== undefined && object.epochNumber !== null) {
            message.epochNumber = BigInt(object.epochNumber.toString());
        }
        return message;
    },
};
function createBaseQueryUnbondingEpochCValueResponse() {
    return {
        unbondingEpochCValue: lscosmos_1.UnbondingEpochCValue.fromPartial({}),
    };
}
exports.QueryUnbondingEpochCValueResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.unbondingEpochCValue !== undefined) {
            lscosmos_1.UnbondingEpochCValue.encode(message.unbondingEpochCValue, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryUnbondingEpochCValueResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.unbondingEpochCValue = lscosmos_1.UnbondingEpochCValue.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryUnbondingEpochCValueResponse();
        if ((0, helpers_1.isSet)(object.unbondingEpochCValue))
            obj.unbondingEpochCValue = lscosmos_1.UnbondingEpochCValue.fromJSON(object.unbondingEpochCValue);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.unbondingEpochCValue !== undefined &&
            (obj.unbondingEpochCValue = message.unbondingEpochCValue
                ? lscosmos_1.UnbondingEpochCValue.toJSON(message.unbondingEpochCValue)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryUnbondingEpochCValueResponse();
        if (object.unbondingEpochCValue !== undefined && object.unbondingEpochCValue !== null) {
            message.unbondingEpochCValue = lscosmos_1.UnbondingEpochCValue.fromPartial(object.unbondingEpochCValue);
        }
        return message;
    },
};
function createBaseQueryHostAccountUndelegationRequest() {
    return {
        epochNumber: BigInt(0),
    };
}
exports.QueryHostAccountUndelegationRequest = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.epochNumber !== BigInt(0)) {
            writer.uint32(8).int64(message.epochNumber);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryHostAccountUndelegationRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.epochNumber = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryHostAccountUndelegationRequest();
        if ((0, helpers_1.isSet)(object.epochNumber))
            obj.epochNumber = BigInt(object.epochNumber.toString());
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.epochNumber !== undefined && (obj.epochNumber = (message.epochNumber || BigInt(0)).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryHostAccountUndelegationRequest();
        if (object.epochNumber !== undefined && object.epochNumber !== null) {
            message.epochNumber = BigInt(object.epochNumber.toString());
        }
        return message;
    },
};
function createBaseQueryHostAccountUndelegationResponse() {
    return {
        hostAccountUndelegation: lscosmos_1.HostAccountUndelegation.fromPartial({}),
    };
}
exports.QueryHostAccountUndelegationResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.hostAccountUndelegation !== undefined) {
            lscosmos_1.HostAccountUndelegation.encode(message.hostAccountUndelegation, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryHostAccountUndelegationResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hostAccountUndelegation = lscosmos_1.HostAccountUndelegation.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryHostAccountUndelegationResponse();
        if ((0, helpers_1.isSet)(object.hostAccountUndelegation))
            obj.hostAccountUndelegation = lscosmos_1.HostAccountUndelegation.fromJSON(object.hostAccountUndelegation);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.hostAccountUndelegation !== undefined &&
            (obj.hostAccountUndelegation = message.hostAccountUndelegation
                ? lscosmos_1.HostAccountUndelegation.toJSON(message.hostAccountUndelegation)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryHostAccountUndelegationResponse();
        if (object.hostAccountUndelegation !== undefined && object.hostAccountUndelegation !== null) {
            message.hostAccountUndelegation = lscosmos_1.HostAccountUndelegation.fromPartial(object.hostAccountUndelegation);
        }
        return message;
    },
};
function createBaseQueryDelegatorUnbondingEpochEntryRequest() {
    return {
        delegatorAddress: "",
        epochNumber: BigInt(0),
    };
}
exports.QueryDelegatorUnbondingEpochEntryRequest = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        if (message.epochNumber !== BigInt(0)) {
            writer.uint32(16).int64(message.epochNumber);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegatorUnbondingEpochEntryRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                case 2:
                    message.epochNumber = reader.int64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryDelegatorUnbondingEpochEntryRequest();
        if ((0, helpers_1.isSet)(object.delegatorAddress))
            obj.delegatorAddress = String(object.delegatorAddress);
        if ((0, helpers_1.isSet)(object.epochNumber))
            obj.epochNumber = BigInt(object.epochNumber.toString());
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.epochNumber !== undefined && (obj.epochNumber = (message.epochNumber || BigInt(0)).toString());
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDelegatorUnbondingEpochEntryRequest();
        message.delegatorAddress = object.delegatorAddress ?? "";
        if (object.epochNumber !== undefined && object.epochNumber !== null) {
            message.epochNumber = BigInt(object.epochNumber.toString());
        }
        return message;
    },
};
function createBaseQueryDelegatorUnbondingEpochEntryResponse() {
    return {
        delegatorUnbodingEpochEntry: lscosmos_1.DelegatorUnbondingEpochEntry.fromPartial({}),
    };
}
exports.QueryDelegatorUnbondingEpochEntryResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.delegatorUnbodingEpochEntry !== undefined) {
            lscosmos_1.DelegatorUnbondingEpochEntry.encode(message.delegatorUnbodingEpochEntry, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDelegatorUnbondingEpochEntryResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorUnbodingEpochEntry = lscosmos_1.DelegatorUnbondingEpochEntry.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryDelegatorUnbondingEpochEntryResponse();
        if ((0, helpers_1.isSet)(object.delegatorUnbodingEpochEntry))
            obj.delegatorUnbodingEpochEntry = lscosmos_1.DelegatorUnbondingEpochEntry.fromJSON(object.delegatorUnbodingEpochEntry);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.delegatorUnbodingEpochEntry !== undefined &&
            (obj.delegatorUnbodingEpochEntry = message.delegatorUnbodingEpochEntry
                ? lscosmos_1.DelegatorUnbondingEpochEntry.toJSON(message.delegatorUnbodingEpochEntry)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDelegatorUnbondingEpochEntryResponse();
        if (object.delegatorUnbodingEpochEntry !== undefined && object.delegatorUnbodingEpochEntry !== null) {
            message.delegatorUnbodingEpochEntry = lscosmos_1.DelegatorUnbondingEpochEntry.fromPartial(object.delegatorUnbodingEpochEntry);
        }
        return message;
    },
};
function createBaseQueryHostAccountsRequest() {
    return {};
}
exports.QueryHostAccountsRequest = {
    encode(_, writer = binary_1.BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryHostAccountsRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const obj = createBaseQueryHostAccountsRequest();
        return obj;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryHostAccountsRequest();
        return message;
    },
};
function createBaseQueryHostAccountsResponse() {
    return {
        hostAccounts: lscosmos_1.HostAccounts.fromPartial({}),
    };
}
exports.QueryHostAccountsResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.hostAccounts !== undefined) {
            lscosmos_1.HostAccounts.encode(message.hostAccounts, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryHostAccountsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.hostAccounts = lscosmos_1.HostAccounts.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryHostAccountsResponse();
        if ((0, helpers_1.isSet)(object.hostAccounts))
            obj.hostAccounts = lscosmos_1.HostAccounts.fromJSON(object.hostAccounts);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.hostAccounts !== undefined &&
            (obj.hostAccounts = message.hostAccounts ? lscosmos_1.HostAccounts.toJSON(message.hostAccounts) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryHostAccountsResponse();
        if (object.hostAccounts !== undefined && object.hostAccounts !== null) {
            message.hostAccounts = lscosmos_1.HostAccounts.fromPartial(object.hostAccounts);
        }
        return message;
    },
};
function createBaseQueryDepositModuleAccountRequest() {
    return {};
}
exports.QueryDepositModuleAccountRequest = {
    encode(_, writer = binary_1.BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDepositModuleAccountRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const obj = createBaseQueryDepositModuleAccountRequest();
        return obj;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = createBaseQueryDepositModuleAccountRequest();
        return message;
    },
};
function createBaseQueryDepositModuleAccountResponse() {
    return {
        balance: coin_1.Coin.fromPartial({}),
    };
}
exports.QueryDepositModuleAccountResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.balance !== undefined) {
            coin_1.Coin.encode(message.balance, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryDepositModuleAccountResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.balance = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryDepositModuleAccountResponse();
        if ((0, helpers_1.isSet)(object.balance))
            obj.balance = coin_1.Coin.fromJSON(object.balance);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.balance !== undefined &&
            (obj.balance = message.balance ? coin_1.Coin.toJSON(message.balance) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryDepositModuleAccountResponse();
        if (object.balance !== undefined && object.balance !== null) {
            message.balance = coin_1.Coin.fromPartial(object.balance);
        }
        return message;
    },
};
function createBaseQueryAllDelegatorUnbondingEpochEntriesRequest() {
    return {
        delegatorAddress: "",
    };
}
exports.QueryAllDelegatorUnbondingEpochEntriesRequest = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.delegatorAddress !== "") {
            writer.uint32(10).string(message.delegatorAddress);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllDelegatorUnbondingEpochEntriesRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorAddress = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryAllDelegatorUnbondingEpochEntriesRequest();
        if ((0, helpers_1.isSet)(object.delegatorAddress))
            obj.delegatorAddress = String(object.delegatorAddress);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAllDelegatorUnbondingEpochEntriesRequest();
        message.delegatorAddress = object.delegatorAddress ?? "";
        return message;
    },
};
function createBaseQueryAllDelegatorUnbondingEpochEntriesResponse() {
    return {
        delegatorUnbondingEpochEntries: [],
    };
}
exports.QueryAllDelegatorUnbondingEpochEntriesResponse = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        for (const v of message.delegatorUnbondingEpochEntries) {
            lscosmos_1.DelegatorUnbondingEpochEntry.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseQueryAllDelegatorUnbondingEpochEntriesResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.delegatorUnbondingEpochEntries.push(lscosmos_1.DelegatorUnbondingEpochEntry.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseQueryAllDelegatorUnbondingEpochEntriesResponse();
        if (Array.isArray(object?.delegatorUnbondingEpochEntries))
            obj.delegatorUnbondingEpochEntries = object.delegatorUnbondingEpochEntries.map((e) => lscosmos_1.DelegatorUnbondingEpochEntry.fromJSON(e));
        return obj;
    },
    toJSON(message) {
        const obj = {};
        if (message.delegatorUnbondingEpochEntries) {
            obj.delegatorUnbondingEpochEntries = message.delegatorUnbondingEpochEntries.map((e) => e ? lscosmos_1.DelegatorUnbondingEpochEntry.toJSON(e) : undefined);
        }
        else {
            obj.delegatorUnbondingEpochEntries = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseQueryAllDelegatorUnbondingEpochEntriesResponse();
        message.delegatorUnbondingEpochEntries =
            object.delegatorUnbondingEpochEntries?.map((e) => lscosmos_1.DelegatorUnbondingEpochEntry.fromPartial(e)) || [];
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.AllState = this.AllState.bind(this);
        this.HostChainParams = this.HostChainParams.bind(this);
        this.DelegationState = this.DelegationState.bind(this);
        this.AllowListedValidators = this.AllowListedValidators.bind(this);
        this.CValue = this.CValue.bind(this);
        this.ModuleState = this.ModuleState.bind(this);
        this.IBCTransientStore = this.IBCTransientStore.bind(this);
        this.Unclaimed = this.Unclaimed.bind(this);
        this.FailedUnbondings = this.FailedUnbondings.bind(this);
        this.PendingUnbondings = this.PendingUnbondings.bind(this);
        this.UnbondingEpochCValue = this.UnbondingEpochCValue.bind(this);
        this.HostAccountUndelegation = this.HostAccountUndelegation.bind(this);
        this.DelegatorUnbondingEpochEntry = this.DelegatorUnbondingEpochEntry.bind(this);
        this.HostAccounts = this.HostAccounts.bind(this);
        this.DepositModuleAccount = this.DepositModuleAccount.bind(this);
        this.DelegatorUnbondingEpochEntries = this.DelegatorUnbondingEpochEntries.bind(this);
    }
    Params(request = {}) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.lscosmos.v1beta1.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new binary_1.BinaryReader(data)));
    }
    AllState(request = {}) {
        const data = exports.QueryAllStateRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.lscosmos.v1beta1.Query", "AllState", data);
        return promise.then((data) => exports.QueryAllStateResponse.decode(new binary_1.BinaryReader(data)));
    }
    HostChainParams(request = {}) {
        const data = exports.QueryHostChainParamsRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.lscosmos.v1beta1.Query", "HostChainParams", data);
        return promise.then((data) => exports.QueryHostChainParamsResponse.decode(new binary_1.BinaryReader(data)));
    }
    DelegationState(request = {}) {
        const data = exports.QueryDelegationStateRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.lscosmos.v1beta1.Query", "DelegationState", data);
        return promise.then((data) => exports.QueryDelegationStateResponse.decode(new binary_1.BinaryReader(data)));
    }
    AllowListedValidators(request = {}) {
        const data = exports.QueryAllowListedValidatorsRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.lscosmos.v1beta1.Query", "AllowListedValidators", data);
        return promise.then((data) => exports.QueryAllowListedValidatorsResponse.decode(new binary_1.BinaryReader(data)));
    }
    CValue(request = {}) {
        const data = exports.QueryCValueRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.lscosmos.v1beta1.Query", "CValue", data);
        return promise.then((data) => exports.QueryCValueResponse.decode(new binary_1.BinaryReader(data)));
    }
    ModuleState(request = {}) {
        const data = exports.QueryModuleStateRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.lscosmos.v1beta1.Query", "ModuleState", data);
        return promise.then((data) => exports.QueryModuleStateResponse.decode(new binary_1.BinaryReader(data)));
    }
    IBCTransientStore(request = {}) {
        const data = exports.QueryIBCTransientStoreRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.lscosmos.v1beta1.Query", "IBCTransientStore", data);
        return promise.then((data) => exports.QueryIBCTransientStoreResponse.decode(new binary_1.BinaryReader(data)));
    }
    Unclaimed(request) {
        const data = exports.QueryUnclaimedRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.lscosmos.v1beta1.Query", "Unclaimed", data);
        return promise.then((data) => exports.QueryUnclaimedResponse.decode(new binary_1.BinaryReader(data)));
    }
    FailedUnbondings(request) {
        const data = exports.QueryFailedUnbondingsRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.lscosmos.v1beta1.Query", "FailedUnbondings", data);
        return promise.then((data) => exports.QueryFailedUnbondingsResponse.decode(new binary_1.BinaryReader(data)));
    }
    PendingUnbondings(request) {
        const data = exports.QueryPendingUnbondingsRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.lscosmos.v1beta1.Query", "PendingUnbondings", data);
        return promise.then((data) => exports.QueryPendingUnbondingsResponse.decode(new binary_1.BinaryReader(data)));
    }
    UnbondingEpochCValue(request) {
        const data = exports.QueryUnbondingEpochCValueRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.lscosmos.v1beta1.Query", "UnbondingEpochCValue", data);
        return promise.then((data) => exports.QueryUnbondingEpochCValueResponse.decode(new binary_1.BinaryReader(data)));
    }
    HostAccountUndelegation(request) {
        const data = exports.QueryHostAccountUndelegationRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.lscosmos.v1beta1.Query", "HostAccountUndelegation", data);
        return promise.then((data) => exports.QueryHostAccountUndelegationResponse.decode(new binary_1.BinaryReader(data)));
    }
    DelegatorUnbondingEpochEntry(request) {
        const data = exports.QueryDelegatorUnbondingEpochEntryRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.lscosmos.v1beta1.Query", "DelegatorUnbondingEpochEntry", data);
        return promise.then((data) => exports.QueryDelegatorUnbondingEpochEntryResponse.decode(new binary_1.BinaryReader(data)));
    }
    HostAccounts(request = {}) {
        const data = exports.QueryHostAccountsRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.lscosmos.v1beta1.Query", "HostAccounts", data);
        return promise.then((data) => exports.QueryHostAccountsResponse.decode(new binary_1.BinaryReader(data)));
    }
    DepositModuleAccount(request = {}) {
        const data = exports.QueryDepositModuleAccountRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.lscosmos.v1beta1.Query", "DepositModuleAccount", data);
        return promise.then((data) => exports.QueryDepositModuleAccountResponse.decode(new binary_1.BinaryReader(data)));
    }
    DelegatorUnbondingEpochEntries(request) {
        const data = exports.QueryAllDelegatorUnbondingEpochEntriesRequest.encode(request).finish();
        const promise = this.rpc.request("pstake.lscosmos.v1beta1.Query", "DelegatorUnbondingEpochEntries", data);
        return promise.then((data) => exports.QueryAllDelegatorUnbondingEpochEntriesResponse.decode(new binary_1.BinaryReader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
//# sourceMappingURL=query.js.map